import SoundOnIcon from "images/icons/20-sound-on.svg";

interface Props {
  className?: string;
}

export const PlayingIndicator: React.FC<Props> = ({ className }) => (
  <div className={`assignment-audio__playing-indicator ${className ?? ""}`}>
    <SoundOnIcon height="25" width="25" />
  </div>
);
